/**
 * Parses date from MM/DD/YY format and extracts shift date/time
 */
export const parseShiftDateAndTime = (dateStr: string, timeStr: string) => {
  if (!dateStr || !timeStr) {
    return { shift_date: '', shift_start_time: '', shift_end_time: '' };
  }

  const [mm, dd, yy] = dateStr.split('/');
  const shift_date = `${mm}/${dd}/${yy}`;
  const [startTime, endTime] = timeStr.split(' TO ');
  
  return {
    shift_date,
    shift_start_time: startTime || '',
    shift_end_time: endTime || '',
  };
};

/**
 * Gets date and time from audit details, with fallbacks
 */
export const getDateAndTimeFromDetails = (details: any, finalJson: any) => {
  let dateToUse = null;
  let timeToUse = null;

  if (finalJson.date && finalJson.time) {
    dateToUse = finalJson.date;
    timeToUse = finalJson.time;
  } else if (details.shift_date_time) {
    const shiftDateTimeParts = details.shift_date_time.split(' ');
    if (shiftDateTimeParts.length >= 3) {
      dateToUse = shiftDateTimeParts[0] + ' ' + shiftDateTimeParts[1];
      timeToUse = shiftDateTimeParts.slice(2).join(' ');
    }
  } else if (details.created_at) {
    const createdDate = new Date(details.created_at);
    const mm = String(createdDate.getMonth() + 1).padStart(2, '0');
    const dd = String(createdDate.getDate()).padStart(2, '0');
    const yy = String(createdDate.getFullYear()).slice(-2);
    dateToUse = `${mm}/${dd}/${yy}`;
    timeToUse = '00:00 TO 23:59';
  }

  return { dateToUse, timeToUse };
};

